<template>
    <div class="createStoreProdcut">


        <div class="basic_info">
            <div class="titleBox" style="display: flex;justify-content: space-between;border-bottom:1px solid #eee;">
                <div class="title">
                    图库详情
                </div>
                <el-button size="medium" @click="editItem()" type="primary"
                    style="position: absolute;right: 140px;top: 20px;height: 38px;">
                    {{ !editStatus ? '编辑' : '确认' }}</el-button>
                <el-button size="medium" @click="goBack()" type="primary"
                    style="position: absolute;right: 30px;top: 20px;"><i class="iconfont icon-fanhui-"></i>
                    {{ $t('other.a605') }}</el-button>
            </div>
            <div class="basic_detail" v-if="!editStatus">

                <div class="ul">
                    <div class="li">
                        <div class="label">版面主图：</div>
                        <img :src="info.imagesUrl" alt="" srcset="" style="width: 180px;">
                    </div>
                    <div class="li">
                        <div class="label">版面名称：</div>
                        <div class="liContent">
                            {{ info.layoutName }}
                        </div>
                    </div>
                    <div class="li">
                        <div class="label">版面类型：</div>
                        <div class="liContent">
                            {{ info.layoutType == 0 || info.layoutType == 1 ? options.find(item => item.value ==
                                info.layoutType).label : '' }}
                        </div>
                    </div>
                    <div class="li">
                        <div class="label">版面型号：</div>
                        <div class="liContent">
                            {{ info.layoutModel }}
                        </div>
                    </div>
                    <div class="li">
                        <div class="label">定制内容：</div>
                        <div class="liContent">
                            {{ info.isCase == 0 ? '默认' : info.isCase == 1 ? '大写' : '小写' }}
                        </div>
                    </div>

                    <div class="cTitle" style="margin-top: 20px;margin-bottom: 10px;">
                        {{ $t('other.a3361') }}：
                    </div>
                    <div class="cUl">
                        <div class="cLTitle">{{ $t('other.a3359') }}</div>
                        <div class="clBox">
                            <div class="cLi" v-for="(item, index) in info.patternSizeList">
                                <!-- <div class="label">{{ $t('other.a3359') }}：</div> -->
                                <div>{{ item.sizeName }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="cTitle" style="margin-top: 20px;margin-bottom: 10px;">
                        {{ $t('other.a3362') }}：
                    </div>
                    <div class="cUl">
                        <div class="cLTitle">{{ $t('other.a3360') }}</div>
                        <div class="clBox">
                            <div class="cLi" v-for="(item, index) in info.patternColourList">
                                <div>{{ item.colourName }}</div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;justify-content: space-between;margin-bottom: 30px;border-top: 1px solid #eee;padding-top: 20px;"
                        v-if="false">
                        <div style="width: 48%;">
                            <div class="cTitle">
                                {{ $t('other.a3361') }}
                            </div>
                            <div class="cUl">
                                <div class="cLTitle">{{ $t('other.a3359') }}</div>
                                <div class="clBox">
                                    <div class="cLi" v-for="(item, index) in info.patternSizeList">
                                        <!-- <div class="label">{{ $t('other.a3359') }}：</div> -->
                                        <div>{{ item.sizeName }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 48%;">
                            <div class="cTitle">
                                {{ $t('other.a3362') }}
                            </div>
                            <div class="cUl">
                                <div class="cLTitle">{{ $t('other.a3359') }}</div>
                                <div class="clBox">
                                    <div class="cLi" v-for="(item, index) in info.patternColourList">
                                        <div>{{ item.colourName }}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="cLi" v-for="(item, index) in info.patternColourList">
                                <div class="label">{{ $t('other.a3360') }}：</div>
                                <div>{{ item.colourName }}</div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="basic_detail editBox" v-else>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a66')" prop="imagesUrl">

                        <el-upload class="avatar-uploader" :headers="token"
                            action="https://erp.shopsbu.com/service/access/upload" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>

                    </el-form-item>
                    <el-form-item :label="$t('other.a3356')" prop="layoutName">
                        <el-input v-model="ruleForm.layoutName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a3357')" prop="layoutType">
                        <el-select v-model="ruleForm.layoutType">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="版面型号" prop="layoutModel">
                        <el-input v-model="ruleForm.layoutModel"></el-input>
                    </el-form-item>
                    <el-form-item label="定制内容" prop="isCase">
                        <el-radio v-model="ruleForm.isCase" :label="0" @click="ruleForm.isCase = 0">默认</el-radio>
                        <el-radio v-model="ruleForm.isCase" :label="1" @click="ruleForm.isCase = 1">大写</el-radio>
                        <el-radio v-model="ruleForm.isCase" :label="2" @click="ruleForm.isCase = 2">小写</el-radio>
                    </el-form-item>
                    <div style="display: flex;justify-content: space-between; padding: 0px 20px;margin-bottom: 30px;">
                        <div style="width: 48%;">
                            <div class="cTitle">
                                {{ $t('other.a3361') }}
                            </div>
                            <div class="cLi" v-for="(item, index) in ruleForm.patternSizeList">
                                <div class="label">{{ $t('other.a3359') }}</div>
                                <el-input v-model="item.sizeName"></el-input>
                                <i v-show="index == 0" @click="setItmes(1, 0, index)"
                                    class="iconfont icon-zengjiatianjiajiajian"></i>
                                <i v-show="!index == 0" @click="setItmes(1, 1, index)" class="iconfont icon-jianshao1"></i>
                            </div>
                        </div>
                        <div style="width: 48%;">
                            <div class="cTitle">
                                {{ $t('other.a3362') }}
                            </div>
                            <div class="cLi" v-for="(item, index) in ruleForm.patternColourList">
                                <div class="label">{{ $t('other.a3360') }}</div>
                                <el-input v-model="item.colourName"></el-input>
                                <i v-show="index == 0" @click="setItmes(2, 0, index)"
                                    class="iconfont icon-zengjiatianjiajiajian"></i>
                                <i v-show="!index == 0" @click="setItmes(2, 1, index)" class="iconfont icon-jianshao1"></i>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>


    </div>
</template>
  
<script>
import galleryApi from '../../api/moudles/gallery'
import draggable from "vuedraggable"
import { mapState, mapMutations } from 'vuex'
import { resolve } from 'path'
export default {
    data() {
        return {
            userId: JSON.parse(localStorage.getItem('userInfo')).userId,
            ruleForm: {
                layoutModel: '',
                layoutName: '',
                imagesUrl: '',
                layoutType: '0',
                layoutState: 1,
                isCase: 0,
                patternColourList: [{ sizeName: '' }],
                patternSizeList: [{ colourName: '' }],
                createUser: JSON.parse(localStorage.getItem('userInfo')).userId,
            },
            rules: {
                layoutName: [
                    { required: true, message: this.$t('other.a3363'), trigger: 'blur' },
                ],
                imagesUrl: [
                    { required: true, message: this.$t('other.a3366'), trigger: 'blur' },
                ],
                layoutType: [
                    { required: true, message: this.$t('other.a3364'), trigger: 'blur' },
                ],
                layoutModel: [
                    { required: true, message: '请输入版面型号', trigger: 'blur' },
                ],
                isCase: [
                    { required: true, message: '请选择定制内容', trigger: 'blur' },
                ],
            },
            options: [{
                label: '字母版',
                value: '0'
            }, {
                label: '动漫版',
                value: '1'
            }],
            token: {
                token: JSON.parse(localStorage.getItem('userInfo')).token
            },
            imageUrl: '',
            pathUrl: '',
            info: {

            },
            editStatus: false
        }
    },

    components: {
        draggable
    },

    inject: ['reload'],

    computed: {//这一部分直接拿过来用的
        ...mapState({
            ModelData: state => state.common.ModelData



        }),





    },

    watch: {

    },



    created() {
        this.init()
    },


    methods: {
        editItem() {
            if (this.editStatus) {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        for (let i = 0; i < this.ruleForm.patternSizeList.length; i++) {
                            if (!this.ruleForm.patternSizeList[i].sizeName) {
                                this.$message.warning(this.$t('other.a3367'))
                                return
                            }
                        }
                        for (let i = 0; i < this.ruleForm.patternColourList.length; i++) {
                            if (!this.ruleForm.patternColourList[i].colourName) {
                                this.$message.warning(this.$t('other.a3368'))
                                return
                            }
                        }
                        galleryApi
                            .editPattern(this.ruleForm)
                            .then(res => {
                                if (res.code === 200) {
                                    this.$message.success(this.$t('other.a2623'))
                                    this.init()
                                    this.editStatus = !this.editStatus
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }else{            
                this.editStatus = !this.editStatus
            }
        },
        setItmes(pIndex, index, nIndex) {
            if (pIndex == 1) {
                if (index == 0) {
                    this.ruleForm.patternSizeList.push({
                        sizeName: ''
                    })
                } else {
                    this.ruleForm.patternSizeList.splice(nIndex, 1)
                }
            } else {
                if (index == 0) {
                    this.ruleForm.patternColourList.push({
                        colourName: ''
                    })
                } else {
                    this.ruleForm.patternColourList.splice(nIndex, 1)
                }
            }
        },
        init() {
            this.pathUrl = JSON.parse(this.$route.query.from)
            galleryApi
                .getPatterneDtail(this.$route.query.patternInfoId)
                .then(res => {
                    console.log(res)
                    if (res.code === 200) {
                        this.info = res.data
                        this.ruleForm = res.data
                        this.imageUrl = res.data.imagesUrl
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },



        goBack() {
            this.$router.push(this.pathUrl)
        },
        handleAvatarSuccess(res, file) {
            console.log(file.response.data)
            this.imageUrl = URL.createObjectURL(file.raw);
            this.ruleForm.imagesUrl = file.response.data
            console.log(this.ruleForm)
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;


        },


    }
}

</script>
  
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.createStoreProdcut {

    // flex:1;
    // margin: 50px 0 0 223px;

    background-color: #eee;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 60px;


    .footer {
        position: fixed;
        background-color: #fff;
        width: 86%;
        bottom: 0;
        height: 70px;
        margin-left: -20px;
        border-top: 1px solid #eee;
        z-index: 15;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        box-shadow: 5px ​4px 23px -6px #606266;

    }

    .basic_info {

        background-color: #fff;
        padding: 0 16px;
        margin-bottom: 25px;



        .attribute {
            display: inline-block;
            min-width: 350px;
            box-sizing: border-box;
            margin-bottom: 10px;

            .attribute_desc {
                display: inline-block;
                width: 150px;
                text-align: right;
            }
        }

        .title {
            height: 68px;
            line-height: 68px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em !important;
            font-family: Roboto, sans-serif !important;
            border-bottom: 1px solid #eee;
        }

        .basic_detail {
            padding: 15px 0;

            .singSku_wrapper {
                display: flex;

                .singSku {
                    display: flex;
                    margin-right: 30px;

                    .inputBox {
                        display: inline-block;
                        width: 180px;
                    }
                }
            }


        }

        .listitem {
            display: inline-block;
            width: 120px;
            height: 120px;
            border-radius: 3px;
            cursor: pointer;
            border: 1px dashed #c0ccda;
            margin: 0 5px;
            position: relative;
        }

        .pic_desc {
            position: absolute;
            bottom: -45px;
            left: 40px;
        }

        .cateGory_wrapper {
            position: relative;
            box-shadow: 0 5px 5px -3px #606266;
            height: 450px;



            .first_wrapper {
                position: absolute;
                top: 0;
                left: 0;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;


                .first_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }

            .second_wrapper {
                position: absolute;
                top: 0;
                left: 350px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;


                .second_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }

            .three_wrapper {
                position: absolute;
                top: 0;
                left: 700px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                .three_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }

            .four_wrapper {
                position: absolute;
                top: 0;
                left: 1050px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                .four_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }


            .category_title {
                position: relative;
                top: 0;
                left: 0;

            }



            .active:hover {
                background-color: #eee;
            }
        }

        .pic_box {

            width: 120px;
            height: 120px;
            position: absolute;
            z-index: 2;
        }

        .listitem::after {
            content: "+";
            font-size: 40px;

            position: absolute;
            top: 48px;
            left: 48px;
            z-index: 1;


        }

        .delete {

            width: 120px;
            background-color: rgba(0, 0, 0, .87);
            color: #fff;
            position: absolute;
            bottom: 0;
            left: 0;
            text-align: center;
            display: none;
            z-index: 99
        }

        .deleteActive {
            display: block;
            z-index: 99
        }



        .icon-zengjiatianjiajiajian {
            color: rgb(64, 211, 242);
            cursor: pointer;
            font-size: 20px;
        }

        .icon-jianshao1 {
            color: rgb(246, 97, 109);
            cursor: pointer;
            font-size: 20px;
        }



    }


    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        border: 1px dashed #66b1ff;
    }

    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }


}

.cTitle {
    font-size: 18px;
    font-weight: bold;
}

.ul {
    width: 80%;
    padding: 0px 20px;

    .li {
        display: flex;
        margin-bottom: 20px;

        .label {
            font-size: 18px;
            width: 100px;
            font-weight: bold;
        }

        .liContent {
            font-size: 18px;
            width: calc(100% - 120px);
            // line-height: 26px;
        }
    }
}

.cUl {
    border: 1px solid #eee;

    .cLTitle {
        text-align: center;
        font-size: 18px;
        line-height: 23px;
        padding: 12px 0px;
        border-bottom: 1px solid #eee;
    }

    .clBox {
        width: 100%;
        overflow-x: auto;
        display: flex;
    }

    .cLi {
        flex: 1;
        border: 1px solid #eee;
        border-top: none;
        border-bottom: none;
        line-height: 23px;
        padding: 12px 10px;
        font-size: 16px;
        text-align: center;
        width: 100px;
        display: inline-block;
        color: rgb(96, 96, 102);
    }
}

.editBox {
    .cLi {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .cLi .label {
        width: 120px;
    }

    .cLi .el-input {
        margin-right: 10px;
    }
}
</style>